module.exports = __webpack_public_path__ + "img/bracket-round.0e39786f.svg";